module.exports = __webpack_public_path__ + "fonts/Poppins-700-1034.305c44f.woff2";